export default __webpack_public_path__ + "static/media/view_more_vector.6b1d3890.svg";